import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {catchError, map} from "rxjs/operators";
import {throwError} from "rxjs";
import {AppConfig} from "../app.config";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    public appConfig: AppConfig,
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  enableDefault() {
    this.renderer.removeClass(this.document.body, 'old-theme');
    this.renderer.addClass(this.document.body, 'default-theme');
  }


  getOverrideCss(partnerID) {

    let env = this.appConfig.getEnvironmentNew();
    const cssUrl = `${env.url}/Portal/OverrideCSS/${partnerID}?code=${env.key}`;


    this.http.get(cssUrl, { responseType: 'text' }).subscribe(
      (cssContent: string) => {
        this.applyCustomCSS(cssContent); // Apply the fetched CSS
      },
      (error) => {
        console.error('Failed to load custom CSS:', error);
      }
    );
  }

  getOverrideUrlCss(domain: string) {

    let env = this.appConfig.getEnvironmentNew();
    const cssUrl = `${env.url}/Global/OverrideCSS/${domain}?code=${env.key}`;


    this.http.get(cssUrl, { responseType: 'text' }).subscribe(
      (cssContent: string) => {
        this.applyCustomCSS(cssContent); // Apply the fetched CSS
      },
      (error) => {
        console.error('Failed to load custom CSS:', error);
      }
    );
  }


  applyCustomCSS(cssContent: string): void {
    // Create a <style> element dynamically
    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.textContent = cssContent; // Add the fetched CSS as content
    document.head.appendChild(styleElement); // Append the <style> to <head>
  }
}
